import { Box, Button, DialogActions, Typography } from '@mui/material';
import React from 'react';
import DefaultModal from '../../components/Modals/DefaultModal';
import { ProjectStatus } from '../../enums/projectStatus';
import { Project } from '../../models/project';

interface Props {
  modalData: { open: boolean; project?: Project };
  closeModal: () => void;
  confirmModal: () => void;
}

const DeleteModal = (props: Props): JSX.Element => {
  return (
    <DefaultModal open={props.modalData.open} handleClose={props.closeModal}>
      <Box sx={{ px: 6 }}>
        <Typography variant="h4" textAlign="center" color="grey.900" mb={2}>
          Are you sure?
        </Typography>
        {props.modalData.project &&
        ProjectStatus[props.modalData.project.status] ===
          ProjectStatus.IN_PROGRESS ? (
          <>
            <Typography mb={1}>
              You are about to close project&nbsp;
              <strong>
                #{props.modalData.project.id} -&nbsp;
                {props.modalData.project.projectTitle}&nbsp;
              </strong>
              that is in <strong>PROGRESS</strong>.
            </Typography>
            <Typography>
              This project will be marked as completed and talent won&apos;t be
              able to submit any further invoices against this project.
            </Typography>
            <Typography>
              Are you sure you want to close this project?
            </Typography>
          </>
        ) : (
          <>
            <Typography textAlign="center" mb={1}>
              The project&nbsp;
              <strong>
                #{props.modalData.project?.id} -&nbsp;
                {props.modalData.project?.projectTitle}&nbsp;
              </strong>
              will be deleted.
            </Typography>
            <Typography textAlign="center">
              Are you sure you want to continue?
            </Typography>
          </>
        )}
      </Box>
      <DialogActions sx={{ justifyContent: 'center', py: 3 }}>
        <Button variant="outlined" onClick={props.closeModal}>
          Cancel
        </Button>
        <Button onClick={props.confirmModal}>Continue</Button>
      </DialogActions>
    </DefaultModal>
  );
};

export default DeleteModal;
